import { useQuery } from "@tanstack/react-query";

import { checkLink } from "@app/services/linkChecker";

export const useLinkChecker = (url, options = {}) => {
  return useQuery({
    queryKey: ["linkChecker", url],
    queryFn: async ({ signal }) => checkLink(url, { signal }),
    throwOnError: false,
    // subscribed: false,
    onError: (error) => {
      console.info("LinkChecker error:", error);
    },
    retry: 0,
    enabled: !!url,
    staleTime: 60 * 60 * 1000, // 1 hour
    ...options,
  });
};
